import { Component } from '@angular/core';
import { BaseModalDirective } from '@app/components/modals/base-modal';

@Component({
    templateUrl: './burial-resources.component.html',
    standalone: false
})
export class BurialResourcesModalComponent extends BaseModalDirective {
    translatedLang = sessionStorage.getItem('currentLang') || 'en';
}
